import { Add } from '@mui/icons-material';
import { List, ListItem } from '@mui/material';

import { TopicsScores } from '@/domain/impact-calculate/entities/calculate.entity';
import { ModelVersionESS } from '@/domain/project/entities/project.entity';
import { VenueDate } from '@/domain/project-venue-dates/entities/project-venue-dates.entity';
import { FSSecondaryButton } from '@/ui/components/button/FSSecondaryButton';
import { translate } from '@/ui/i18n';
import { ColorsRaw } from '@/ui/theme/colors-raw';

import { MonthHeader } from './components/MonthHeader';
import { VenueDateItem } from './components/VenueDateItem';

export function VenueDatesMonthView({
  monthDate,
  venueDates,
  scoresByMonth,
  scoresByDates,
  onClickAdd,
  onClickEditDay,
  onClickEditMonth,
  onClickDelete,
  onClickPresets,
  onSelectPreset,
  isSelecting,
  selectedIds,
  onToggleSelect,
  allSelectedInMonth,
  someSelectedInMonth,
  onToggleAllForMonth,
}: {
  monthDate: string;
  venueDates: VenueDate[];
  scoresByMonth: Record<string, TopicsScores>;
  scoresByDates: Record<number, TopicsScores>;
  onClickAdd: () => void;
  onClickEditDay: (
    id: number,
    modelESS: ModelVersionESS,
    scrollTo?: string,
  ) => void;
  onClickEditMonth: (monthDate: string) => void;
  onClickDelete: (id: number) => void;
  onClickPresets: () => void;
  onSelectPreset: (venueDateId: number, presetId: number) => void;
  isSelecting: boolean;
  selectedIds: Set<number>;
  onToggleSelect: (id: number) => void;
  allSelectedInMonth: boolean;
  someSelectedInMonth: boolean;
  onToggleAllForMonth: () => void;
}) {
  return (
    <List
      sx={{
        border: '1px solid',
        borderColor: ColorsRaw.anthracite.Anthracite_4,
        borderRadius: 4,
      }}
      subheader={
        <MonthHeader
          monthDate={monthDate}
          scoresByMonth={scoresByMonth}
          onClickEditMonth={onClickEditMonth}
          isSelecting={isSelecting}
          allSelectedInMonth={allSelectedInMonth}
          someSelectedInMonth={someSelectedInMonth}
          onToggleAllForMonth={onToggleAllForMonth}
        />
      }
    >
      {venueDates.map((venueDate) => (
        <VenueDateItem
          key={venueDate.id}
          venueDate={venueDate}
          scoresByDates={scoresByDates}
          onClickEditDay={onClickEditDay}
          onClickDelete={onClickDelete}
          onClickPresets={onClickPresets}
          onSelectPreset={onSelectPreset}
          isSelecting={isSelecting}
          isSelected={selectedIds.has(venueDate.id)}
          onToggleSelect={onToggleSelect}
        />
      ))}
      <ListItem>
        <FSSecondaryButton onClick={onClickAdd} startIcon={<Add />}>
          {translate('ProjectsVenue.add-dates')}
        </FSSecondaryButton>
      </ListItem>
    </List>
  );
}
